<template>
  <v-card class="ma-6">
    <v-card-title>
      <v-icon color="primary" class="mr-6">developer_board</v-icon>
      Part Groups
      <div class="flex-grow-1"></div>
      <div class="flex-grow-1"></div>
      <v-text-field color="green" v-model="search" append-icon="search" label="Search by Name or Keywords" single-line
        hide-details></v-text-field>
    </v-card-title>

    <v-data-table class="row-pointer" dense :headers="headers" :options.sync="options" @click:row="rowClicked"
      :items="items" :server-items-length="totalItems" :footer-props="{
        itemsPerPageOptions: [10, 20, 100, 500, -1]
      }" :search="search" loading-text="Loading...please wait" :loading="loading">
      <template v-slot:top>
        <AddButton :onClick="addPartGroup" />
      </template>
    </v-data-table>
  </v-card>

</template>

<style lang="css" scoped>
.row-pointer>>>tbody tr :hover {
  cursor: pointer;
}
</style>

<script>
import { PartGroupsService } from '../services/api/partGroups';
import AddButton from '../components/data-table/AddButton.vue'
import _ from "lodash";

const apiPartGroups = new PartGroupsService();

export default {
    data() {
        return {
            totalItems: 0,
            items: [],
            loading: true,
            options: {
                itemsPerPage: 20,
            },
            search: "",
            headers: [
                { text: "ID", value: "id", hidden: true, align: " d-none" },
                { text: "Name", value: "name" },
                { text: "Words to Include", value: "wordsToInclude" },
                { text: "Words to Exclude", value: "wordsToExclude" },
                { text: "Def Refined Min Qty", value: "defaultRefinedMinQty" },
                { text: "Def Qty Cap", value: "defaultQtyCap" },
                { text: "Def Min Qty to Scan", value: "defaultMinQtyToScan" },
                { text: "Category IDs", value: "categoryIDs" }
            ],
        };
    },
    watch: {
        options: {
            handler() {
                this.loadItems();
            },
            deep: true,
        },
        // Watch for changes to the search text.
        search: function () {
            this.debouncedloadItems();
        }
    },
    created: function () {
        this.debouncedloadItems = _.debounce(this.loadItems, 500);
    },
    methods: {
        loadItems() {
            this.loading = true;
            return new Promise((resolve, reject) => {
                this.getPartGroups();
            });
        },
        getPartGroups() {
            this.loading = true;
            // Clear our list so the loading text will be shown.
            this.items = [];
            // Set up our search, sort, and paging parameters
            const search = {
                searchText: this.search,
                // If there's a sortBy field set, then use it; otherwise use a reasonable default.
                sortOrderField: this.options.sortBy.length == 1 ? this.options.sortBy[0] : "Name",
                // If there's no sortDesc defined, sort by desc.  Otherwise sort by the value.
                sortDirection: this.options.sortDesc.length == 0 ? "asc" : (this.options.sortDesc[0] ? "desc" : "asc"),
                itemsPerPage: this.options.itemsPerPage,
                itemsToSkip: this.options.itemsPerPage * (this.options.page - 1),
            };
            // Get the list of items from the API.
            apiPartGroups.getPartGroups(search).then((data) => {
                this.items = data.items;
                this.totalItems = data.totalItemCount;
            });
            this.loading = false;
        },
        // When a row is clicked, go to the detail page.
        rowClicked(item) {
            this.$router.push({ name: "PartGroupEdit", params: { id: item.id } });
        },
        async addPartGroup() {
            const name = prompt("Enter the name of the new Part Group");
            if (name == null || name.trim() == "") {
                return;
            }
            const newPartGroup = await apiPartGroups.savePartGroup({
                name: name.trim(),
                wordsToInclude: "",
                wordsToExclude: "",
                defaultRefinedMinQty: 5,
                defaultQtyCap: 100,
                defaultMinQtyToScan: 1,
                categoryIDs: ""
            });
            await this.$router.push({ name: "PartGroupEdit", params: { id: newPartGroup.id } });
        },
    },
    components: { AddButton }
}
</script>